import { observable, action } from 'mobx';
import { Cases } from 'api';

class CasesStore {
  @observable cases = {
    debitorName: '',
    opened: [],
    closed: [],
  };

  @observable fetchState;

  anketId;

  @action.bound
  async getCases(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Cases.getCases(anketId);
      this.cases = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const casesStore = new CasesStore();

export default casesStore;
